// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__IxKfZ","inner":"Form_inner__cemdK","range":"Form_range__2qaeE","name":"Form_name__1oClb","actions":"Form_actions__2n6mQ"};